import Icon from '../components/Icon.vue'

Icon.register({"eject":{"width":448,"height":512,"paths":[{"d":"M448 384V448C448 465.7 433.7 480 416 480H32C14.3 480 0 465.7 0 448V384C0 366.3 14.3 352 32 352H416C433.7 352 448 366.3 448 384zM48.1 320H399.9C441.6 320 463.5 270.3 435.3 239.6L259.4 47.6C240.4 26.8 207.6 26.8 188.6 47.6L12.7 239.6C-15.5 270.3 6.3 320 48.1 320z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/eject.js